a// Pour une documentation complète sur API, incluant des exemples de code, allez sur http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});